const findVars = /(\{[^{}]+\})/g;

export const getSegments = (str: string): string[] =>
    str.split(findVars).filter(Boolean);
